import React from 'react';
import PropTypes from 'prop-types';

import format from '../Form/PhoneNumberInput/format';
import normalizePhoneNumber from '../Form/PhoneNumberInput/normalizePhoneNumber';
import { useTranslation } from 'react-i18next';

const PhoneNumber = ({ children, isFormatted, hide }) => {
  const { t } = useTranslation();
  if (!children && hide) {
    return null;
  }

  if (!children) {
    return <span>-</span>;
  }

  const phoneLink = isFormatted ? `${t("tel")}:${normalizePhoneNumber(children)}` : `${t("tel")}:${children}`;
  return <a href={phoneLink}>{isFormatted ? children : format(children)}</a>;
};

PhoneNumber.defaultProps = {
  children: undefined,
  isFormatted: false,
  hide: false,
};

PhoneNumber.propTypes = {
  children: PropTypes.string,
  isFormatted: PropTypes.bool,
  hide: PropTypes.bool,
};

export default PhoneNumber;
